import React from 'react';
import { Tooltip } from '@cognite/cogs.js';
import { useLiveValidation } from 'utils/graphqlValidation';
import { DisabledCodeEditor } from 'components/DisabledCodeEditor/DisabledCodeEditor';

type Props = {
  code: string;
  disabled?: boolean;
  disabledMessage?: string;
  height?: string;
};

export const GraphqlCodeEditor = ({
  code,
  disabledMessage,
  disabled = false,
  height = '500px',
}: Props) => {
  const { mountLiveValidator } = useLiveValidation();

  return (
    <Tooltip content={disabledMessage} disabled={!disabled || !disabledMessage}>
      <div style={{ width: '100%' }}>
        <DisabledCodeEditor
          width="100%"
          height={height}
          language="graphql"
          value={code}
          onMount={(editor) => mountLiveValidator(editor)}
        />
      </div>
    </Tooltip>
  );
};
